import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Transaktionen", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_TransactionContainer = _resolveComponent("TransactionContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, [
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.date,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
        type: "daterange",
        "unlink-panels": "",
        "range-separator": "bis",
        "start-placeholder": "Start Datum",
        "end-placeholder": "End Datum",
        shortcuts: _ctx.shortcuts,
        onChange: _ctx.reload
      }, null, 8, ["modelValue", "shortcuts", "onChange"])
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.customerValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customerValue) = $event)),
        onChange: _ctx.reload,
        clearable: "",
        filterable: "",
        placeholder: "Nach Käufer filtern"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: user.id,
              label: user.lastName + ' ' +  user.firstName,
              value: user.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_select, {
        modelValue: _ctx.cashierValue,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cashierValue) = $event)),
        onChange: _ctx.reload,
        clearable: "",
        filterable: "",
        placeholder: "Nach Kassierer filtern"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: user.id,
              label: user.lastName + ' ' +  user.firstName,
              value: user.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"])
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.state,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state) = $event)),
        onChange: _ctx.reload,
        clearable: "",
        style: {"width":"400px"},
        placeholder: "Transaktion Status"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateOptions, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"])
    ]),
    _createVNode(_component_TransactionContainer, {
      transactions: _ctx.transactions,
      administration: "true",
      onRefunded: _ctx.reload
    }, null, 8, ["transactions", "onRefunded"])
  ]))
}